import * as React from 'react';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { ItemCardButtons } from 'components';
import { IItemCardProps, IItemCardButtonsProps } from 'models/itemcard';
import { ArticleStatus } from 'models/enums/statuses';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { truncateText, thumbUrl } from 'helpers/common';
import { INodeData } from 'models/common';
import moment = require('moment');
import { Tags } from 'components/Magazine/Article/Tag/Tags';
require('./style.scss');

interface IProps extends IItemCardProps {
	item: IArticleListCard;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MagazineArticleItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public goToCard(e: any) {
		e.preventDefault();
		if (this.props.goToCard) {
			const entityIdObj: INodeData = JSON.parse(this.props.item.entityId);
			this.props.goToCard(entityIdObj.id, entityIdObj.type);
		}
	}

	public editItem() {
		if (this.props.editItem !== undefined) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.editItem(entityIdObj.id);
		}
	}

	public deleteItem() {
		if (this.props.deleteItem !== undefined) {
			const entityIdObj: any = JSON.parse(this.props.item.entityId);
			this.props.deleteItem(entityIdObj.type, entityIdObj.id);
		}
	}

	public render() {
		const { currentUserId, currentUserIsAdministrator, currentUserIsEditor } = this.props;
		const { name, picture, addedBy, addedDate, status, userId, tags } = this.props.item;

		const itemCardButtonsProps: IItemCardButtonsProps = {
			editItem:
				this.props.editItem !== undefined &&
				((status !== ArticleStatus.Approved && currentUserId === userId) ||
					currentUserIsAdministrator ||
					currentUserIsEditor)
					? this.editItem
					: null,
			deleteItem:
				this.props.deleteItem !== undefined &&
				((status !== ArticleStatus.Approved && currentUserId === userId) || currentUserIsAdministrator)
					? this.deleteItem
					: null,
		};

		let pictureHolder: JSX.Element = null;
		if (picture) {
			pictureHolder = <div style={{ backgroundImage: `url(${thumbUrl(picture)})` }} />;
		}

		return (
			<div className="col-lg-4 col-md-6 col-sm-12 magazineArticleItemCard">
				<a href="#" onClick={this.goToCard} className="image">
					{pictureHolder}
				</a>
				<div>
					<Tags tags={tags} displayNumber={2} onClick={true} />
				</div>
				<div className="title mobileShown">
					<a href="#" onClick={this.goToCard}>
						{truncateText(name, 40)}
					</a>
				</div>
				<div className="textContent">
					<div className="title desktopShown">
						<a href="#" onClick={this.goToCard}>
							{truncateText(name, 40)}
						</a>
					</div>
					<div className="author">
						<p className="p12 text author">{addedBy}</p>
						<span className={'author-separator'}>&#8226;</span>
						<p className="p12 text gray date">{moment(addedDate).format('L')}</p>
					</div>
				</div>
				<ItemCardButtons {...itemCardButtonsProps} />
			</div>
		);
	}
}

export { MagazineArticleItemCard };
